export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10646.54e564a3.jpg";